export const queryKeysFactory = (name: string) => {
  const keys = {
    all: [name] as const,
    lists: () => [...keys.all, 'list'] as const,
    list: (filters: string[] = []) => [...keys.lists(), ...filters] as const,
    details: () => [...keys.all, 'detail'] as const,
    detail: (id: string | number) => [...keys.details(), id] as const,
  };

  return keys;
};
